import React, { Component } from 'react'
import styled from '@emotion/styled'

import { Link as GatsbyLink } from 'gatsby'

const LinkStyles = setTheme => `
	font-size: inherit;
	text-decoration: none;
	cursor: pointer;
`

const StyledLinkElement = styled.a`
	${ ({ setTheme }) => `
		${ LinkStyles(setTheme) }
	` }
`

const StyledGatsbyLink = styled(GatsbyLink)`
	${ ({ theme }) => `
		${ LinkStyles(theme) }
	` }
`

class Link extends Component {
	render () {
		const { to = '#', external = false, target = '', children, label, className, setTheme = 'alert', title } = this.props
		if (external) {
			return (
				<StyledLinkElement
					title={title}
					className={className}
					href={to}
					target={target}
					theme={setTheme}
					rel='noopener noreferrer'
				>
					{children || label}
				</StyledLinkElement>
			)
		} else {
			return (
				<StyledGatsbyLink
					title={title}
					className={className}
					to={to}
					theme={setTheme}
				>
					{children || label}
				</StyledGatsbyLink>
			)
		}
	}
}

export default Link
